export const CommonChars = {
    Blank: '',
    Space: ' ',
    Hyphen: '-',
    Underscore: '_',
    Comma: ',',
    Period: '.',
    Hash: '#'
}